export const FALLBACK_LANG = 'ru';
export const LANGUAGES = ['ru', 'en', 'uz', 'de'] as const;
export const LOCAL_STORAGE_LANGUAGE = 'preferred-language';
export type Language = (typeof LANGUAGES)[number];
